import cx from 'classnames';
import {Button} from '~library/atoms/Button';
import {DiamondIcon} from '~library/svg/DiamondIcon';

export const RemoveAdsButton = ({sidePanel, removeOnClick, useFakeAds}) => {
  return (
    <div
      className={cx('google-free-banner__wrapper', {
        'google-free-banner__wrapper--side-panel': sidePanel,
        'google-free-banner__wrapper--create-flow': useFakeAds,
      })}
    >
      <div className="view-invitation__preview-cta multi">
        <Button
          variant="link"
          className="view-invitation__preview-cta"
          data-qa-id="remove-banners"
          id="remove-banner"
          onClick={removeOnClick}
          icon={<DiamondIcon className="remove_button__premium-diamond" ratio={1.143} />}
        >
          Remove Ads
        </Button>
      </div>
    </div>
  );
};
